import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Dots Vertical" (three vertical dots / more options).
 */
@Component({
  selector: 'app-icon-dots-vertical',
  templateUrl: './icon-dots-vertical.component.html',
  styleUrls: ['./icon-dots-vertical.component.scss'],
  standalone: false,
})
export class IconDotsVerticalComponent {

  @Input() tooltip?: string;

}
